import fetch from "../../auth/FetchInterceptor";

export const getAppointments = function (from, to) {
  return fetch({
    url: `/appointments?from=${from}&to=${to}`,
    method: 'get',
  })
}

export const getAppointment = function (id) {
  return fetch({
    url: `/appointments/${id}`,
    method: 'get',
  })
}

export const createAppointment = (data) => {
  return fetch({
    url: `/appointments`,
    method: 'POST',
    data,
  });
}

export const updateAppointment = (id, data) => {
  return fetch({
    url: `/appointments/${id}`,
    method: 'PUT',
    data,
  });
}

export const deleteAppointment = (id) => {
  return fetch({
    url: `/appointments/${id}`,
    method: 'DELETE',
  });
}